"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionLinkDisabled = exports.actionLinkUnderline = exports.actionLinkCustomColor = exports.actionLinkBase = void 0;

var _stylitas = require("@creditas/stylitas");

const actionLinkBase = ({
  theme
}) => (0, _stylitas.css)`
  ${_stylitas.utilities.typography.action(theme)};
  ${_stylitas.utilities.radius.small()};
  display: inline-flex;
  align-items: center;
  text-align: left;
  cursor: pointer;
  padding: 16px 32px 16px 16px;

  &:hover {
    color: ${theme.bColorsecondary06};
  }

  &:focus {
    outline: none;
    ${_stylitas.utilities.border.thin({
  theme,
  color: theme.bColorsecondary04
})};
  }
`;

exports.actionLinkBase = actionLinkBase;

const actionLinkCustomColor = ({
  theme,
  color
}) => (0, _stylitas.css)`
  color: ${color ? color : theme.bColorsecondary04};
`;

exports.actionLinkCustomColor = actionLinkCustomColor;

const actionLinkUnderline = ({
  underline
}) => (0, _stylitas.css)`
  text-decoration: ${underline};
`;

exports.actionLinkUnderline = actionLinkUnderline;

const actionLinkDisabled = ({
  theme,
  disabled
}) => disabled && (0, _stylitas.css)`
    color: ${theme.bColorneutral04};
    cursor: not-allowed;

    &:hover,
    &:focus,
    &:visited,
    &:link {
      border: none;
      color: ${theme.bColorneutral04};
    }
  `;

exports.actionLinkDisabled = actionLinkDisabled;